import { render, staticRenderFns } from "./CountriesChart.vue?vue&type=template&id=249edbba&scoped=true&"
import script from "./CountriesChart.vue?vue&type=script&lang=js&"
export * from "./CountriesChart.vue?vue&type=script&lang=js&"
import style0 from "./CountriesChart.vue?vue&type=style&index=0&id=249edbba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249edbba",
  null
  
)

export default component.exports